import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin",
  "use": "pin-usage",
  "viewBox": "0 0 18 26",
  "content": "<symbol viewBox=\"0 0 18 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 .5A8.744 8.744 0 00.25 9.25C.25 15.813 9 25.5 9 25.5s8.75-9.688 8.75-16.25A8.744 8.744 0 009 .5zm0 11.875a3.126 3.126 0 010-6.25 3.126 3.126 0 010 6.25z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id